import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { OrderWorkConditionsForm } from 'sections/LKSection/modules/OrderModule/components/Forms/OrderWorkConditionsForm/OrderWorkConditionsForm'
import { validateWorkConditions } from 'sections/LKSection/modules/OrderModule/components/Forms/OrderWorkConditionsForm/validate'
import { getCreateOrderPageKey } from 'sections/LKSection/modules/OrderModule/utils'
import { DEFAULT_END_TIME, DEFAULT_START_TIME } from 'sections/LKSection/shared/PickPointSharedModule/data'
import { PickPointType } from 'sections/LKSection/shared/PickPointSharedModule/types'
import { Margin } from 'components/ui'
import { Button, Flex, Title } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { sendEvent } from 'utils/helpers/sendEvent'
import { EventType } from 'types/types'

import s from './WorkConditionsStep.module.scss'

export type WorkConditionsStepType = {
  area: number
  warehouseArea: number
  cellingHeight: number
  dressingRoomsCount: number
}

export const WorkConditionsStep = observer(() => {
  const { createOrderUiStore: uiStore } = useStore()

  const { t } = useTranslation()

  const location = uiStore.location

  useEffect(() => {
    if (location.pickPointType !== PickPointType.folk) {
      uiStore.workConditions.timetable.setTimetableStart(DEFAULT_START_TIME)
      uiStore.workConditions.timetable.setTimetableEnd(DEFAULT_END_TIME)
    }
  }, [location.pickPointType])

  const nextStepHandler = () => {
    if (validateWorkConditions.validate(uiStore.workConditions)) {
      sendEvent(EventType.orderStep, { step: 3, success: 1 })
      uiStore.setSelectedStep(uiStore.selectedStep + 1)
    } else {
      sendEvent(EventType.orderStep, { step: 3, success: 0, reason: 'Не пройдена валидация' })
    }
  }

  return (
    <Flex className={s.WorkConditionsStep} vertical gap={24}>
      <Title level={3}>{t(getCreateOrderPageKey('Условия работы'))}</Title>

      <Flex vertical>
        <OrderWorkConditionsForm
          uiStore={uiStore.workConditions}
          isCreation
          pickPointType={location.pickPointType ?? PickPointType.partner}
          floorLevel={uiStore.location.floorLevel}
        />

        <Margin mt={24}>
          <Flex gap={8}>
            <Button
              onClick={() => uiStore.setSelectedStep(uiStore.selectedStep - 1)}
              type="default"
              data-testid="previousStepInWorkConditions"
            >
              {t(getCreateOrderPageKey('Предыдущий шаг'))}
            </Button>

            <Button onClick={nextStepHandler} data-testid="nextStepAfterWorkConditions">
              {t(getSharedKey('next'))}
            </Button>
          </Flex>
        </Margin>
      </Flex>
    </Flex>
  )
})
